// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uP01V","subtitle":"styles_subtitle__ull-y"};